import {translations} from 'presentation/translations-new';

import {isAdvanceDiagnosticsAppointment} from '../isAdvanceDiagnosticsAppointment';
import {GetAppointmentClinicNameParams} from './types';

const {advanceDiagnostics} = translations['pt-br'].privateFlow.services;

export const getAppointmentClinicName = ({
	appointment,
	isAdvanceDiagnosticsExamsJourneyEnabled,
}: GetAppointmentClinicNameParams) =>
	isAdvanceDiagnosticsAppointment({appointment, isAdvanceDiagnosticsExamsJourneyEnabled})
		? advanceDiagnostics
		: appointment.clinicName;
